<ng-container *ngIf="participant">
  <div class="row" >
    <div class="col-md-12 col-lg-6">
      <div class="row">
        <div class="col-sm-10">
            <button id="{{idPrefix}}btn.import_participant_data_from_addressbook"
                    mat-flat-button
                    color="accent"
                    class="w-100 mt-3 mb-3"
                    (click)="openImportFromAddressBookModal(participant)">
                <mat-icon>book</mat-icon>{{ 'detailed_processing.participant.btn.import_from_address_book' | translate }}
            </button>
          <mat-card class="mb-3">
            <address-participant [idPrefix]="idPrefix"
                                 [bananaBox]="original"
                                 [config]="addressParticipantOptions"
                                 [disabled]="(disabled)"
                                 (bananaBoxChange)="onChildParticipantUpdate($event)">
            </address-participant>
          </mat-card>
        </div>
        <div class="col-sm-2">
          <!-- PLACEHOLDER FOR ACTION BUTTONS-->
        </div>
      </div>
    </div>


    <div class="col-md-12 col-lg-6">

      <!-- COMMON ELEMENT FOR ALL PARTICIPANTS -->
      <div class="row mb-2" style="padding-top: 10px;">
        <div class="col-sm-10">
          <mat-radio-group [(ngModel)]="isCompany"
                           (change)="patchAndUpdate('is_company')"
                           [disabled]="disabled"
                           style="padding-top: 8px;">
            <mat-radio-button id="{{idPrefix}}{{participant.trans.citizen}}" labelPosition="after" value="false" style="margin-right: 50px;">{{ participant.trans.citizen | translate }}</mat-radio-button>
            <mat-radio-button id="{{idPrefix}}{{participant.trans.company}}" labelPosition="after" value="true">{{ participant.trans.company | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>

      <!-- CURRENTLY ONLY SHOWING THE SUB TYPE FOR TYPE WITNESS -->
      <div class="row" *ngIf="showSubTypes">
        <div class="col-sm-10">
          <div class="row no-gutters">
            <mat-form-field class="full-width">
              <mat-label>{{ participant.trans.sub_type | translate }}</mat-label>
              <mat-select id="{{idPrefix}}{{participant.trans.sub_type}}"
                          [(ngModel)]="participant.sub_type"
                          (ngModelChange)="patchAndUpdate('sub_type')"
                          [disabled]="disabled">
                <mat-option *ngFor="let subType of ParticipantSubTypes.ALL; let idx = index"
                            id="{{idPrefix}}{{participant.trans.sub_type}}.item_{{idx}}"
                            [value]="subType.key">
                  {{ subType.trans | translate }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- COMMON ELEMENT FOR ALL PARTICIPANTS -->
      <div class="row">
        <div class="col-sm-10">
          <div class="row no-gutters">
            <mat-form-field class="full-width">
              <mat-label>{{ participant.trans.comment | translate }}</mat-label>
              <textarea id="{{idPrefix}}{{participant.trans.comment}}"
                        matInput
                        rows="12"
                        [(ngModel)]="participant.comment"
                        (blur)="patchAndUpdate('comment')"
                        [disabled]="disabled"
              ></textarea>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm-2">
          <!-- PLACEHOLDER FOR ACTION BUTTONS-->
        </div>
      </div>

      <div class="row">
        <div class="col-sm-10">
          <mat-form-field class="full-width mt-3">
            <mat-label>{{ participant.trans.cost_center | translate }}</mat-label>
            <input
              id="{{idPrefix}}input_text.{{ participant.trans.cost_center }}"
              type="text" matInput
              [(ngModel)]="participant.cost_center"
              [disabled]="!!disabled"
              (blur)="patchAndUpdate('cost_center')"
              >
          </mat-form-field>
        </div>
      </div>

      <!-- BLOCK FOR REFERENCE CASE NUMBER (DYNAREX ... ) -->

      <div class="full-width mb-3" *ngIf="showReferenceNumber">

        <div class="row no-gutters mb-1">
          <div class="col-sm-10 smp-title">{{ 'detailed_processing.participant.title.references' | translate }}</div>
        </div>

        <div class="row">
          <div class="col-sm-10">
            <div class="row no-gutters">
              <mat-form-field class="full-width">
                <mat-label>{{ participant.trans.reference_number | translate }}</mat-label>
                <input id="{{idPrefix}}{{participant.trans.reference_number}}"
                       type="text" matInput
                       [(ngModel)]="participant.reference_number "
                       [disabled]="disabled"
                       (blur)="patchAndUpdate('reference_number')">
              </mat-form-field>
            </div>
          </div>
          <div class="col-sm-2">
            <!-- PLACEHOLDER FOR ACTION BUTTONS-->
          </div>
        </div>
      </div>

      <!-- BLOCK WHICH IS CURRENTLY ONLY SHOWN FOR PARTICIPANT TYPE 'VEHICLE_INSURANCE' -->

      <div *ngIf="showCustomerInsuranceInfo" class="full-width">

        <div class="row no-gutters mb-1">
          <div class="col-sm-10 smp-title">{{ 'detailed_processing.participant.title.insurance_information' | translate }}</div>
        </div>

        <div class="row">
          <div class="col-sm-10">
            <div class="row no-gutters">
              <mat-form-field class="full-width">
                <mat-label>{{ case.trans.insurance_number | translate }}</mat-label>
                <input id="{{idPrefix}}{{case.trans.insurance_number}}"
                       type="text" matInput
                       [(ngModel)]="case.insurance_number"
                       [disabled]="disabled"
                       (blur)="patchAndUpdateCase('insurance_number', case.insurance_number)">
              </mat-form-field>
            </div>
          </div>
          <div class="col-sm-2">
            <!-- PLACEHOLDER FOR ACTION BUTTONS-->
          </div>
        </div>

        <div class="row">
          <div class="col-sm-10">
            <div class="row no-gutters">
              <mat-form-field class="full-width">
                <mat-label>{{ case.trans.claim_number | translate }}</mat-label>
                <input id="{{idPrefix}}{{case.trans.claim_number}}"
                       type="text" matInput
                       [(ngModel)]="case.claim_number"
                       [disabled]="disabled"
                       (blur)="patchAndUpdateCase('claim_number', case.claim_number)"
                >
              </mat-form-field>
            </div>
          </div>
          <div class="col-sm-2">
            <!-- PLACEHOLDER FOR ACTION BUTTONS-->
          </div>
        </div>

        <div class="row mb-2">

          <div class="col-sm-10">

            <div class="row no-gutters">

              <div class="col-sm-4 dr-checkbox-container" style="padding-right: 6px;">
                <dr-checkbox [idPrefix]="idPrefix"
                             [idSuffix]="InsuranceTypes.FULL_COMPREHENSIVE.trans"
                             [boolValue]="coveredClaimTypeIsFull"
                             [label]="InsuranceTypes.FULL_COMPREHENSIVE.trans | translate"
                             [disabled]="disabled"
                             (updated)="coveredClaimTypeIsFull = $event.value">
                </dr-checkbox>
              </div>

              <div class="col-sm-4 dr-checkbox-container" style="padding-right: 3px; padding-left: 3px;">
                <dr-checkbox [idPrefix]="idPrefix"
                             [idSuffix]="InsuranceTypes.PARTIAL_COMPREHENSIVE.trans"
                             [boolValue]="coveredClaimTypeIsPartial"
                             [label]="InsuranceTypes.PARTIAL_COMPREHENSIVE.trans | translate"
                             [disabled]="disabled"
                             (updated)="coveredClaimTypeIsPartial = $event.value">
                </dr-checkbox>
              </div>

              <div class="col-sm-4 dr-checkbox-container" style="padding-left: 6px;">
                <dr-checkbox [idPrefix]="idPrefix"
                             [idSuffix]="InsuranceTypes.LIABILITY.trans"
                             [boolValue]="coveredClaimTypeIsLiability"
                             [label]="InsuranceTypes.LIABILITY.trans | translate"
                             [disabled]="disabled"
                             (updated)="coveredClaimTypeIsLiability = $event.value">
                </dr-checkbox>
              </div>

            </div>
          </div>
          <div class="col-sm-2">
            <!-- PLACEHOLDER FOR ACTION BUTTONS-->
          </div>
        </div>

        <div class="row">
          <div class="col-sm-10">
            <div class="row no-gutters">
              <mat-form-field class="full-width">
                <mat-label>{{ case.trans.insurance_participation | translate }}</mat-label>
                <input id="{{idPrefix}}{{case.trans.insurance_participation}}"
                       type="text" matInput currency
                       [(ngModel)]="case.insurance_participation"
                       [disabled]="disabled"
                       (blur)="patchAndUpdateCase('insurance_participation', case.insurance_participation)">
              </mat-form-field>
            </div>
          </div>
          <div class="col-2 align-self-center pl-3">
              {{ currency.currency_display_name }}
          </div>
        </div>
      </div>

      <!-- BLOCK WHICH IS CURRENTLY ONLY SHOWN FOR PARTICIPANT TYPE 'VEHICLE_INSURANCE' -->

      <div *ngIf="showOpponentInsuranceInfo" class="full-width">

        <div class="row no-gutters mb-1">
          <div class="col-sm-10 smp-title">{{ 'detailed_processing.participant.title.insurance_information' | translate }}</div>
        </div>

        <div class="row">
          <div class="col-sm-10">
            <div class="row no-gutters">
              <mat-form-field class="full-width">
                <mat-label>{{ case.accident.opponent.trans.insurance_number | translate }}</mat-label>
                <input id="{{idPrefix}}{{case.accident.opponent.trans.insurance_number}}"
                       type="text" matInput
                       [(ngModel)]="case.accident.opponent.insurance_number"
                       [disabled]="disabled"
                       (blur)="patchAndUpdateCase('accident.opponent.insurance_number', case.accident.opponent.insurance_number)"
                >
              </mat-form-field>
            </div>
          </div>
          <div class="col-sm-2">
            <!-- PLACEHOLDER FOR ACTION BUTTONS-->
          </div>
        </div>

        <div class="row">
          <div class="col-sm-10">
            <div class="row no-gutters">
              <mat-form-field class="full-width">
                <mat-label>{{ case.accident.opponent.trans.claim_number | translate }}</mat-label>
                <input id="{{idPrefix}}{{case.accident.opponent.trans.claim_number}}"
                       type="text" matInput
                       [(ngModel)]="case.accident.opponent.claim_number"
                       [disabled]="disabled"
                       (blur)="patchAndUpdateCase('accident.opponent.claim_number', case.accident.opponent.claim_number)"
                >
              </mat-form-field>
            </div>
          </div>
          <div class="col-sm-2">
            <!-- PLACEHOLDER FOR ACTION BUTTONS-->
          </div>
        </div>

        <div class="row">
          <div class="col-sm-10">
            <div class="row no-gutters">
              <mat-form-field class="full-width">
                <mat-label>{{ case.accident.opponent.trans.green_card_number | translate }}</mat-label>
                <input id="{{idPrefix}}{{case.accident.opponent.trans.green_card_number}}"
                       type="text" matInput
                       [(ngModel)]="case.accident.opponent.green_card_number"
                       [disabled]="disabled"
                       (blur)="patchAndUpdateCase('accident.opponent.green_card_number', case.accident.opponent.green_card_number)"
                >
              </mat-form-field>
            </div>
          </div>
          <div class="col-sm-2">
            <!-- PLACEHOLDER FOR ACTION BUTTONS-->
          </div>
        </div>
      </div>


      <!-- BLOCK WITH BANK INFORMATION -->

      <div *ngIf="showBankInfo" class="full-width">
        <div class="row no-gutters mb-1">
          <div class="col-sm-10 smp-title">{{ 'detailed_processing.participant.title.bank_information' | translate }}</div>
        </div>

        <div class="row">
          <div class="col-sm-10">
            <div class="row no-gutters">
              <mat-form-field class="full-width">
                <mat-label>{{ participant.bank.trans.owner | translate }}</mat-label>
                <input id="{{idPrefix}}{{participant.bank.trans.owner}}"
                       type="text" matInput
                       [(ngModel)]="participant.bank.owner"
                       [disabled]="disabled"
                       (blur)="patchAndUpdate('bank.owner')"
                >
              </mat-form-field>
            </div>
          </div>
          <div class="col-sm-2">
            <!-- PLACEHOLDER FOR ACTION BUTTONS-->
          </div>
        </div>

        <div class="row">
          <div class="col-sm-10">
            <div class="row no-gutters">
              <mat-form-field class="full-width">
                <mat-label>{{ participant.bank.trans.name | translate }}</mat-label>
                <input id="{{idPrefix}}{{participant.bank.trans.name}}"
                       type="text" matInput
                       [(ngModel)]="participant.bank.name"
                       [disabled]="disabled"
                       (blur)="patchAndUpdate('bank.name')"
                >
              </mat-form-field>
            </div>
          </div>
          <div class="col-sm-2">
            <!-- PLACEHOLDER FOR ACTION BUTTONS-->
          </div>
        </div>

        <div class="row">
          <div class="col-sm-10">
            <div class="row no-gutters">
              <mat-form-field class="full-width">
                <mat-label>{{ participant.bank.trans.iban | translate }}</mat-label>
                <input id="{{idPrefix}}{{participant.bank.trans.iban}}"
                       type="text" matInput
                       [(ngModel)]="participant.bank.iban"
                       [disabled]="disabled"
                       (blur)="patchAndUpdate('bank.iban')"
                >
              </mat-form-field>
            </div>
          </div>
          <div class="col-sm-2">
            <!-- PLACEHOLDER FOR ACTION BUTTONS-->
          </div>
        </div>

        <div class="row">
          <div class="col-sm-10">
            <div class="row no-gutters">
              <mat-form-field class="full-width">
                <mat-label>{{ participant.bank.trans.bic | translate }}</mat-label>
                <input id="{{idPrefix}}{{participant.bank.trans.bic}}"
                       type="text" matInput
                       [(ngModel)]="participant.bank.bic"
                       [disabled]="disabled"
                       (blur)="patchAndUpdate('bank.bic')"
                >
              </mat-form-field>
            </div>
          </div>
          <div class="col-sm-2">
            <!-- PLACEHOLDER FOR ACTION BUTTONS-->
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="row no-gutters mt-4"
       *ngIf="extraTypes">
    <div class="col-sm-12 smp-title mb-3">{{ additionalTypeTitle | translate }}</div>
    <div class="col"
         [ngClass]="{'col-sm-12': extraTypes.length > 2}">
      <dynamic-checkboxes [idPrefix]="(idPrefix + 'types.')"
                          [current]="participant.type"
                          [options]="extraTypes"
                          [disabledOptions]="disabledTypes"
                          [patchPath]="'type'"
                          [disabled]="disabled"
                          (updated)="patchAndUpdateWithValue($event)">
      </dynamic-checkboxes>
    </div>
  </div>
</ng-container>
